import { defineStore } from 'pinia'

export const generalStore = defineStore('general', {
    state: () => ({
        mouseHideOverride: false,
        mousing: true,
        scrollY: 0,
        pageHeight: 1,
        hideNav: false,
        count: 0,
        size: '1920x1080',
        sizes: ['3840x2160', '1920x1080', '1280x720', '160x60'],
        mouseTimeout: null,
        fadeInterval: 4000,
        windowSize: {w: 0, h: 0},
        pointerBannerClosed: false,
        isTouchDevice: null
    }),
    actions: {
        startTimeToFade() {
            if(this.isTouchDevice) {
                this.mousing=true;
                return;
            }
            if(this.mouseHideOverride) {
                this.mouseTimeout=null;
                this.mousing=true;
                return;
            }

            this.mouseTimeout=setTimeout(() => {
                this.mousing=!this.mouseHideOverride ? false : true;
            }, this.fadeInterval);
        },
    }
});
